import React, { FunctionComponent } from 'react';
import { NotificationBell } from '@rbx/creator-hub-navigation';
import { useRobloxAuthentication } from '@rbx/auth';

const NotificationTray: FunctionComponent<React.PropsWithChildren> = () => {
  const { user: authenticatedUser } = useRobloxAuthentication();

  if (authenticatedUser === null) {
    return null;
  }

  return <NotificationBell user={authenticatedUser} />;
};

export default NotificationTray;
